module.exports = __webpack_public_path__ + "../resources/images/illustration_attachment-c8ec3d7a764f5cadadae953326f3bccb.svg";